import { render } from "./String.vue?vue&type=template&id=522f57d4"
import script from "./String.vue?vue&type=script&lang=js"
export * from "./String.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__